import React, {useContext} from 'react'

//Node Modules
import { Link } from 'react-router-dom'
import ListGroup from 'react-bootstrap/ListGroup'
import parse from 'html-react-parser'

//Components
import { PdfFileIcon, LockedIcon } from 'components/SASIcon'
import ContentLink from 'components/ContentLink'

//Styles
import styles from './Result.module.scss'

//Context
import { LanguageContext } from 'context/language-context'

//Types 
import { SearchResult } from 'types/search'
import { HELP_DOCSET_ALIAS} from 'util/constants'

interface Props {
  result: SearchResult,
  locked: boolean,
  isActive: boolean,
  onHide: ()=>void
}

const checkHTML = function(html:string) {
  var doc = document.createElement('div');
  doc.innerHTML = html;
  return ( doc.innerHTML === html );
}

const Result = ({ result, locked, isActive, onHide}:Props) => {
  const currentLanguage = useContext(LanguageContext)
  const [topic] = result.contentTitle.split(" :: ")
  const { 
    docset, 
    description, 
    docsetVersion,
    docsetTitle,
    contentTitle,
    fileName,
    type
  } = result

  if (type === 'pdf') {
    const link = '/api/docsets/'+docset+'/'+docsetVersion+'/content/'+fileName+'?locale='+currentLanguage
    return (
      <ListGroup.Item className={`result pdfResult`} as={Link} to={link} target="_blank" onClick={onHide} disabled={locked} rel="noopener">
        {
          <>
          <div className={styles.icon}>
            <PdfFileIcon />
          </div>
          <div className={`${styles.topic} topic`}>
            {topic}
            {locked ? <span className={`${styles.icon} lock`}><LockedIcon /></span>: null}
          </div>
        </>
        }
      </ListGroup.Item>
    )
  } else {
    return (
      <ListGroup.Item bsPrefix={`result ${isActive ? styles.active : ''}`} onClick={onHide}>
        <ContentLink className={'list-group-item'} docsetAlias={docset} docsetCFR={docsetVersion} page={fileName} help={docset === HELP_DOCSET_ALIAS}>
          <div className={styles.topic}>
            {topic} 
            {locked ? <span className={`${styles.icon} lock`}><LockedIcon /></span> : null}
          </div>
          <div className={styles.docset}>{docsetTitle ? docsetTitle : contentTitle}</div>
          <div className={styles.description}>{checkHTML(description) ? parse(description) : description}</div>
        </ContentLink>
      </ListGroup.Item>
    )
  }
}

export default Result